module.exports = __webpack_public_path__ + "img/global.7dc67064.png";